const login = localStorage.getItem("login");
const token = localStorage.getItem("token");
import jwt_decode from "jwt-decode";

if (token !== null) {
  var decoded = jwt_decode(token);
  if (+new Date(decoded.exp * 1000) < +new Date()) {
    localStorage.clear();
    Auth.authenticated = false;
  }
}

class Auth {
  constructor() {
    this.authenticated = login === "true" ? true : false;
  }

  login(cb) {
    this.authenticated = true;
    cb();
  }

  logout(cb) {
    this.authenticated = false;
    cb();
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/Auth.js